// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3qUK3","title":"ClientReferral_title__3PMBA","itemText":"ClientReferral_itemText__BCVbZ"};